import {Swiper, Navigation, Thumbs, Pagination} from 'asteq.swiper';
import {BaseDetailSlider} from 'asteq.sliders.basedetailslider';
import {Zoom} from 'asteq.sliders.zoom';

export class DetailSlider extends BaseDetailSlider {
    constructor(sliderBlock, params) {
        super(sliderBlock, params);

        this.zoom = null;
        this.processParams(params);
    }

    processParams(params) {
        if (!params) {
            return;
        }

        if (params.zoom) {
            this.initZoom(params.zoom);
        }
    }

    initZoom(zoomParams) {
        if (!zoomParams) {
            return;
        }

        this.zoom = new Zoom({
            modalId: zoomParams.modalId,
            zoomSliderId: zoomParams.zoomSliderId,
            parentSlider: this,
        });

        this.zoom.initParentSlidesEvents();
        this.subscribe('afterSetImages', this.zoom.onAfterSetImagesParent.bind(this.zoom));
    }

    initSwipers() {
        let firstSlide = null;

        if (this.thumbsSwiperBlock) {
            this.thumbsSwiper = new Swiper(this.thumbsSwiperBlock, {
                modules: [Navigation],
                navigation: {
                    prevEl: this.thumbsSwiperBlock.querySelector('.swiper-button-prev.swiper-thumb-navigation'),
                    nextEl: this.thumbsSwiperBlock.querySelector('.swiper-button-next.swiper-thumb-navigation'),
                },
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: !0,
            });

            if (this.thumbsSwiper && this.thumbsSwiper.initialized) {
                firstSlide = this.thumbsSwiper.slides[0];
                if (firstSlide) {
                    this.thumbsSwiperSlideTemplate = firstSlide.cloneNode(true);
                }
            }
        }

        if (this.mainSwiperBlock) {
            let thumbsParams = null;
            if (this.thumbsSwiper) {
                thumbsParams = {
                    swiper: this.thumbsSwiper,
                    slideThumbActiveClass: "!opacity-100",
                };
            }

            this.mainSwiper = new Swiper(this.mainSwiperBlock, {
                modules: [Navigation, Thumbs],
                navigation: {
                    prevEl: this.mainSwiperBlock.querySelector('.swiper-button-prev.swiper-main-navigation'),
                    nextEl: this.mainSwiperBlock.querySelector('.swiper-button-next.swiper-main-navigation'),
                },
                thumbs: thumbsParams,
            });

            if (this.mainSwiper && this.mainSwiper.initialized) {
                firstSlide = this.mainSwiper.slides[0];
                if (firstSlide) {
                    this.mainSwiperSlideTemplate = firstSlide.cloneNode(true);
                }
            }
        }

        if (this.thumbsSwiper) {
            this.thumbsSwiper.update();
        }
    }
}